import React from "react";
import { Col, Row, Stack } from "react-bootstrap";
import { User } from "../../types/user";
import PageTitle from "../ui/PageTitle";
import GuardianCard from "./GuardianCard";

interface GuardianTabState {
  users: User[];
}

const GuardianTab = ({ users }: GuardianTabState) => {
  return (
    <>
      <Row className="mb-5">
        <Col xs={12}>
          <Stack gap={3}>
            {users.length > 0 && <PageTitle title="Primary Adults" type="section" descriptionText="Views and follows their own case." />}
            {users.length > 0 ? (
              users
                .slice()
                .sort((a: any, b: any) => {
                  // Sort by casename first
                  const caseCompare = (a.casename || "").localeCompare(b.casename || "");
                  if (caseCompare !== 0) {
                    return caseCompare;
                  }
                  // Then sort by firstname
                  return (a.firstname || "").localeCompare(b.firstname || "");
                })
                .map((user: any, index: number) => <GuardianCard key={user?.id ?? index} user={user} />)
            ) : (
              <div className="mt-2">
                <p className="mb-1">No Primary Adult User Records</p>
                <p className="text-muted small mb-0">Views and follows their own case.</p>
              </div>
            )}
          </Stack>
        </Col>
      </Row>
    </>
  );
};

export default GuardianTab;
